import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { BrandPlanTactic } from 'types'
import { TACTIC_PROVIDERS } from '../../../../constants'

export const useProviders = (tactic: BrandPlanTactic): ExternalIntegrationEnum[] => {
  const { data: brandPlan } = useCurrentBrandPlan()

  const blogPlatform = brandPlan?.selected_blog_platform
  const seoProvider = !blogPlatform || blogPlatform === 'generic' ? ExternalIntegrationEnum.WordPress : blogPlatform

  const emailPlatform = brandPlan?.selected_email_platform
  const emailProvider =
    !emailPlatform || emailPlatform === 'generic' ? ExternalIntegrationEnum.Mailchimp : emailPlatform

  return {
    ...TACTIC_PROVIDERS,
    [BrandPlanTactic.SEO]: [seoProvider],
    [BrandPlanTactic.Email]: [emailProvider],
  }[tactic]
}
